import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

const router = createRouter({
    history: createWebHistory(),
    routes: [{
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Login.vue'),
        meta: {
            title: 'Login',
            auth: false
        }
    }, {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Register.vue'),
        meta: {
            title: 'Register',
            auth: false
        }
    }, {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/ForgotPassword.vue'),
        meta: {
            title: 'Forgot Password',
            auth: false
        }
    }, {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/ResetPassword.vue'),
        props: route => ({ token: route.query.token, email: route.query.email }),
        meta: {
            title: 'Reset Password',
            auth: false
        }
    }, {
        path: '/',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */'@/views/dashboard/Index.vue'),
        meta: {
            title: 'Dashboard',
            auth: true
        },
    }]
});

router.beforeEach(async (to, from) => {
    console.log('router navigate to: ', to);

    if (to.meta.auth) {
        let status = await loggedIn().catch(() => {
            // Empty store
            store.commit('auth/setCurrentUser', null);
            store.commit('track/setTracks', []);
            store.commit('scene/setScene', {
                settings: {}
            });
            store.commit('scene/setScenes', []);
            store.commit('modal/setModal', null);

            return false;
        })

        if (!status) {
            return {
                path: '/login'
            }
        }

        store.dispatch('track/getTracks');
    }
});

// Check if we have current user logged in
async function loggedIn() {
    console.log('router store', store.state.auth.currentUser);
    if (store.state.auth.currentUser) {
        return true;
    }

    // store.dispatch('socketManager/setupConnection');

    // store.dispatch('track/getTracks');
    return await store.dispatch('auth/getCurrentUser', 'router');
}

export default router;
